import StatisticsDashboard from './StatisticsDashboard';

/**
 * Mi desempeño: el tablero de estadísticas de atención con solo las atenciones y agendas del profesional del usuario,
 * más la comparación anónima contra el promedio de su especialidad. El tablero es `StatisticsDashboard`, el mismo de
 * «Estadísticas de atención».
 */
export default function ProfessionalPerformanceView() {
    return <StatisticsDashboard mode="mine" />;
}
